import { render, staticRenderFns } from "./ExportArea.vue?vue&type=template&id=122456b2&"
import script from "./ExportArea.vue?vue&type=script&lang=js&"
export * from "./ExportArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports